<template>
  <van-popup class="outPopup" v-model="sharePopupData.isShow" position="bottom" :style="{ height: '100%' }">
    <div class="box">
      <!-- <van-image class="poster" fit="contain" src="https://youp-read.leqilucky.com/upaiyun/ShareProduct/20210127/4714681556898133624.jpeg" /> -->
      <img ref="poster" class="poster" :src="sharePopupData.posterPic" />
      <van-share-sheet v-model="sharePopupData.isShow" title="分享给好友" :options="options" :overlay="false" @select="onSelect" />
    </div>
  </van-popup>
</template>

<script>
import { Popup, ShareSheet, Image as VanImage } from 'vant'
export default {
  name: 'SharePopup',
  props: {
    sharePopupData: {
      type: Object,
      default() {
        return {
          isShow: false,
          posterPic: ''
        }
      }
    }
  },
  data() {
    return {
      show: true,
      options: [
        { name: '微信', icon: 'wechat', scene: 'WXSceneSession', type: 2 },
        { name: '朋友圈', icon: require('@/assets/image/icon-pengyouquan.png'), scene: 'WXSenceTimeline', type: 2 },
        { name: '保存到相册', icon: require('@/assets/image/icon-xiangce.png'), scene: 'savePic', type: 2 }
      ]
    }
  },
  components: {
    'van-popup': Popup,
    'van-share-sheet': ShareSheet,
    'van-image': VanImage
  },
  methods: {
    onSelect(option) {
      option.posterPic = this.posterPic
      this.$emit('onSelect', option)
      this.showShare = false
    }
  },
  watch: {
    'sharePopupData.isShow'() {
      this.$nextTick(function() {
        let clientHeight = document.documentElement.clientHeight
        let currentShareBoxHeight = document.getElementsByClassName('van-popup--round')[0].offsetHeight
        let currentPosterHeight = clientHeight - currentShareBoxHeight - 20
        this.$refs.poster.style.height = `${currentPosterHeight}px`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  justify-content: space-around;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .poster {
    display: block;
    width: auto;
    height: 0;
    margin-top: 10px;
    border-radius: 5px;
  }
}
.van-popup.outPopup {
  background-color: transparent;
}
</style>
